import React from 'react';
import EmptyTopNav from 'components/topNav/EmptyTopNav';
import { Link } from 'react-router-dom';

const Reset = () => {
    return (
        <div className="logout">
            <EmptyTopNav />

            <h1>Your invitation has expired. Please contact support.</h1>

            <div>
                <span className="u-text-secondary">
                    <Link to={'/login'} className="c-link c-link--primary">
                        Return to login.
                    </Link>
                </span>
            </div>
        </div>
    );
};

export default Reset;
